import { getSubEntities } from '#entities/components/lib/entities'
import type { SerializedEntity } from '#entities/lib/entities'

export async function addWorksEditions (works: SerializedEntity[]) {
  await Promise.all(works.map(addWorkEditions))
}

async function addWorkEditions (work: SerializedEntity) {
  work.editions = await getSubEntities('work', work.uri)
}

export const isOtherEditionWithCover = (currentEdition: SerializedEntity) => (edition: SerializedEntity) => {
  return (edition.uri !== currentEdition.uri) && edition.image
}
